declare global {
  interface Window {
    $aivo: any;
  }
}

export function getAivo(): any {
  return window?.$aivo;
}

export function getAivoChat(): any {
  return getAivo()?.chat;
}

export function aivoChatSendMessage(message: string): any {
  getAivoChat()?.sendMessage(message);
}
